module.exports = __webpack_public_path__ + "img/jl.ea71860a.png";